module.exports = __webpack_public_path__ + "img/CS-UL-I_Overview-Front_1.c83ba20f.jpg";